import DivIconMarker from "./DivIconMarker";
import { LeafletMouseEvent } from "leaflet";
import PrecipMarker, { PrecipM } from "./PrecipMarker";
import classNames from "classnames";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../models/Root";
import { IPrecipSensor } from "../models/PrecipSensor";
import { ISensorDisplayPrecip } from "../models/SensorDisplay";

interface PrecipSensorViewProps {
  sensor: IPrecipSensor;
  display: ISensorDisplayPrecip;
}
const PrecipSensorView = observer(
  ({ sensor, display }: PrecipSensorViewProps) => {
    const { interval, measure } = display;

    const {
      menus: { panel },
      sensors: { setSensor, selected },
    } = useRootStore();

    const isSelected = selected && selected.sensor.id === sensor.id;

    const { position, intensityUnit, totalUnit: depthUnit, latest } = sensor;

    const depth = sensor.totalFor(interval);
    const intensity = sensor.intensityFor(interval);

    const container = {
      tagName: "div",
      className: classNames("selectable-marker", {
        "is-selected": isSelected,
      }),
    };

    const eventHandlers =
      panel === "measure"
        ? {}
        : {
            click: (e: LeafletMouseEvent) => {
              setSensor(sensor);
            },
          };
    const marker = { position, eventHandlers };

    if (latest === null) {
      return (
        <DivIconMarker key={sensor.id} marker={marker} container={container}>
          <PrecipM />
        </DivIconMarker>
      );
    }

    return (
      <DivIconMarker key={sensor.id} marker={marker} container={container}>
        <PrecipMarker
          measure={measure}
          depth={depth}
          intensity={intensity}
          depthUnit={depthUnit}
          intensityUnit={intensityUnit}
        ></PrecipMarker>
      </DivIconMarker>
    );
  }
);

const PrecipSensorsLayer = ({ display }: { display: ISensorDisplayPrecip }) => {
  const {
    sensors: { precipSensors },
  } = useRootStore();

  const interval = display.interval;
  const sorter = (a: IPrecipSensor, b: IPrecipSensor) =>
    (a.totalFor(interval) || 0) - (b.totalFor(interval) || 0);

  return (
    <>
      {precipSensors.sort(sorter).map((sensor) => (
        <PrecipSensorView
          key={sensor.id}
          sensor={sensor}
          display={display}
        ></PrecipSensorView>
      ))}
    </>
  );
};

export default observer(PrecipSensorsLayer);
